import React from 'react'
import styled from 'styled-components'
import tab1 from '../../assets/images/tab1.png'
import tab2 from '../../assets/images/tab2.png'
import tab3 from '../../assets/images/tab3.png'
import tab4 from '../../assets/images/tab4.png'
import tab5 from '../../assets/images/tab5.svg'
import liquidity from '../../assets/images/liquidity.png';
import { NavLink } from 'react-router-dom'

const Tab = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 8px 16px;
  border-top: 1px solid #e5e6eb;
  @media (min-width: 769px) {
    display: none;
  }
`

{
  /* <NavLink  className={pathname === '/swap' || pathname === '/pool' ? 'active' : ''}>
                    Swap
                  </NavLink> */
}

export default function index() {
  return (
    <Tab>
      <NavLink to={'/swap'}>
        <img src={tab5} width={24} alt="" />
      </NavLink>
      <NavLink to={'/pool'}>
        <img src={liquidity} width={24} alt="" />
      </NavLink>
      <NavLink to={'/explore'}>
        <img src={tab4} width={24} alt="" />
      </NavLink>
      {/* <a href='https://bridge.tokchain.org' target='_bank'>
        <img src={tab1} width={24} alt="" />
      </a>

      <a href='https://staking.vn.com/tokStaking' target='_bank'>
        <img src={tab2} width={24} alt="" />
      </a>
      <a href="https://staking.vn.com/" target="_bank">
        <img src={tab3} width={24} alt="" />
      </a> */}
    </Tab>
  )
}
